import{createContext as e}from"react";const t=(t,r={})=>{const n=e({descendants:[],registerDescendant:()=>()=>{},...r});return n.displayName=t,n};export{t as createDescendantContext};
//# sourceMappingURL=createDescendantsContext.js.map
